import { Component, HostListener, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TarjetasSidebarComponent } from '../../../shared/cards-sidebar/cards-sidebar.component';
import { RouterModule } from '@angular/router';
// import { SearchModalComponent }  from '../../shared/search-modal/search-modal.component';
import { InputSearchComponent } from '../../../shared/input-search/input-search.component';
import { SearchModalComponent } from '../../../shared/search-modal/search-modal.component';
import { CloseSectionButtonComponent } from '../../../shared/close-section-button/close-section-button.component';
import { SidebarService } from '../../services/sidebar.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    TarjetasSidebarComponent,
    RouterModule,
    InputSearchComponent,
    SearchModalComponent,
    CloseSectionButtonComponent,
  ],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  sidebarVisible: boolean | undefined;
  @Input() isSmallScreen = false;
  private sidebarService = inject(SidebarService);

  private shouldIgnoreHotkeyTarget(target: EventTarget | null): boolean {
    if (!(target instanceof HTMLElement)) return false;
    const tagName = target.tagName.toLowerCase();
    if (tagName === 'input' || tagName === 'textarea' || tagName === 'select') {
      return true;
    }
    if (target.isContentEditable) return true;
    return false;
  }

  @HostListener('window:keydown', ['$event'])
  onWindowKeydown(event: KeyboardEvent): void {
    this.handleGlobalKeyDown(event);
  }

  handleGlobalKeyDown(event: KeyboardEvent) {
    if (this.shouldIgnoreHotkeyTarget(event.target)) return;

    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      this.openSearchModal();
    }
  }

  showSearchModal = false;
  searchResults: { id: number; name: string }[] = [];

  openSearchModal() {
    this.showSearchModal = true;
    this.sidebarService.setSearchModalOpen(true);
    if (this.isSmallScreen) {
      this.sidebarVisible = false;
    }
  }

  closeSearchModal() {
    this.showSearchModal = false;
    this.searchResults = [];
    this.sidebarService.setSearchModalOpen(false);
  }
}
